import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Footer = function Footer(_ref) {
  var children = _ref.children;
  return _jsx(FooterWrapper, {
    children: children
  });
};

var FooterWrapper = /*#__PURE__*/_styled("div", true ? {
  target: "e1e474a90"
} : {
  target: "e1e474a90",
  label: "FooterWrapper"
})(true ? {
  name: "2uxqqp",
  styles: "display:grid;gap:14px;padding:20px"
} : {
  name: "2uxqqp",
  styles: "display:grid;gap:14px;padding:20px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbi9Nb2JpbGVOYXZpZ2F0aW9uL0Zvb3Rlci9Gb290ZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1nQyIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL05hdmlnYXRpb24vTW9iaWxlTmF2aWdhdGlvbi9Gb290ZXIvRm9vdGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgRkMsIFByb3BzV2l0aENoaWxkcmVuIH0gZnJvbSAncmVhY3QnXG5cbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5leHBvcnQgY29uc3QgRm9vdGVyOiBGQzxQcm9wc1dpdGhDaGlsZHJlbj4gPSAoeyBjaGlsZHJlbiB9KSA9PiA8Rm9vdGVyV3JhcHBlcj57Y2hpbGRyZW59PC9Gb290ZXJXcmFwcGVyPlxuXG5jb25zdCBGb290ZXJXcmFwcGVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZ3JpZDtcbiAgZ2FwOiAxNHB4O1xuICBwYWRkaW5nOiAyMHB4O1xuYFxuXG5leHBvcnQgZGVmYXVsdCBGb290ZXJcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default Footer;